import React, { ReactNode } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Stripe public key should be in an environment variable for security and flexibility
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 
  "pk_test_51IP45QHmKoM90dWU15cj4OjhAoMgFbdrWElNNObYrHHxYUY9XonNa0fdkOl0RQRJxldRf3DUpojvamzUH3bSN3OL00sAPzWaeW";

// Initialize Stripe once
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

interface StripeProviderProps {
  children: ReactNode;
}

/**
 * Provides Stripe Elements context to payment components
 */
const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeProvider; 